import { render, staticRenderFns } from "./bsp-table.vue?vue&type=template&id=b943bb60&scoped=true&"
import script from "./bsp-table.vue?vue&type=script&lang=js&"
export * from "./bsp-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b943bb60",
  null
  
)

export default component.exports